import { z } from 'zod'

export const ContentfulCancellationPoliciesRequestParamsSchema = z.object({
  locale: z.string(),
  preview: z.coerce.boolean().optional(),
})

export type ContentfulCancellationPoliciesRequestParams = z.infer<
  typeof ContentfulCancellationPoliciesRequestParamsSchema
>

export const CancellationPoliciesSchema = z.object({
  carHireDefault: z.string(),
  experienceDefault: z.string(),
  experienceBadWeather: z.string(),
  experienceInsufficientTravelers: z.string(),
  flightDefault: z.string(),
  noRefundAfterDate: z.string(),
  duringStayCancellation: z.string(),
  fullyRefundableBefore: z.string(),
  conditionalNonRefundable: z.string(),
  partialPenalty: z.string(),
  hotelNonRefundable: z.string(),
  hotelRefundable: z.string(),
  hotelRefundablePartial: z.string(),
  noAmendmentsIncludingNameOrDate: z.string(),
  refundable: z.string(),
  nonRefundable: z.string(),
  partiallyRefundable: z.string(),
})

export type CancellationPolicies = z.infer<typeof CancellationPoliciesSchema>
